(function () {
  'use strict';

  var footerSelector = '.kk-footer';
  var buttonSelector = '[data-kk-footer-accordion-button]';
  var desktopQuery = window.matchMedia('(min-width: 1024px)');

  function syncButton(button) {
    var accordion = button.closest('.has-accordion');
    if (!accordion) return;

    var desktop = desktopQuery.matches;
    button.disabled = desktop;
    button.setAttribute(
      'aria-expanded',
      String(desktop || accordion.classList.contains('accordion--active'))
    );
  }

  function syncFooter(footer) {
    footer.querySelectorAll(buttonSelector).forEach(syncButton);
  }

  function initialize(footer) {
    if (!footer || footer.dataset.kkAccordionReady === 'true') return;
    footer.dataset.kkAccordionReady = 'true';

    syncFooter(footer);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (!mutation.target.classList.contains('has-accordion')) return;
        var button = mutation.target.querySelector(buttonSelector);
        if (button) syncButton(button);
      });
    });

    footer.querySelectorAll('.has-accordion').forEach(function (accordion) {
      observer.observe(accordion, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function initializeAll(root) {
    if (root.matches && root.matches(footerSelector)) initialize(root);
    if (root.querySelectorAll) root.querySelectorAll(footerSelector).forEach(initialize);
  }

  function syncAll() {
    document.querySelectorAll(footerSelector).forEach(syncFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    }, { once: true });
  } else {
    initializeAll(document);
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', syncAll);
  } else {
    desktopQuery.addListener(syncAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
